var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',[_c('font-awesome-icon',{staticClass:"copyright-icon",attrs:{"icon":"copyright"}}),_vm._v(" "+_vm._s(_vm.user.name)+" ")],1),_c('SocialBar',{attrs:{"links":_vm.links}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }